// extracted by mini-css-extract-plugin
export default {"container":"ModalBookCall-module--container--2MGZH","button":"ModalBookCall-module--button--1WE8W","buttonClose":"ModalBookCall-module--buttonClose--3hjKt"};